/**
 * PDF Viewer Component
 * Handles PDF preview modal functionality
 */

class PDFViewer {
  constructor() {
    this.modal = null;
    this.iframe = null;
    this.previewButtons = [];
    this.closeButtons = [];
    
    this.init();
  }

  init() {
    // Find all preview buttons and modals
    this.previewButtons = document.querySelectorAll('.pdf-viewer__preview-btn');
    this.modal = document.querySelector('.pdf-viewer__modal');
    
    if (!this.modal) return;
    
    this.iframe = this.modal.querySelector('.pdf-viewer__iframe');
    this.closeButtons = this.modal.querySelectorAll('[data-modal-close]');
    
    this.bindEvents();
  }

  bindEvents() {
    // Preview button click handlers
    this.previewButtons.forEach(button => {
      button.addEventListener('click', this.handlePreviewClick.bind(this));
    });

    // Close button handlers
    this.closeButtons.forEach(button => {
      button.addEventListener('click', this.handleCloseClick.bind(this));
    });

    // Keyboard event handlers
    document.addEventListener('keydown', this.handleKeydown.bind(this));
  }

  handlePreviewClick(event) {
    event.preventDefault();
    
    const button = event.currentTarget;
    const pdfUrl = button.dataset.pdfUrl;
    
    if (!pdfUrl) {
      console.error('PDF URL not found');
      return;
    }

    this.openModal(pdfUrl);
  }

  handleCloseClick(event) {
    event.preventDefault();
    this.closeModal();
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.isModalOpen()) {
      this.closeModal();
    }
  }

  openModal(pdfUrl) {
    if (!this.modal || !this.iframe) return;

    // Set iframe source with viewer
    this.iframe.src = pdfUrl + '#view=FitH';

    // Show modal
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // Focus management
    const firstFocusable = this.modal.querySelector('.pdf-viewer__modal-close');
    if (firstFocusable) {
      firstFocusable.focus();
    }
  }

  closeModal() {
    if (!this.modal || !this.iframe) return;

    // Hide modal
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    // Clear iframe source to stop loading
    setTimeout(() => {
      this.iframe.src = '';
    }, 300);
  }

  isModalOpen() {
    return this.modal && this.modal.getAttribute('aria-hidden') === 'false';
  }
}

// Initialize components when DOM is ready
function initPDFViewer() {
  new PDFViewer();
}

// Initialize on DOM content loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPDFViewer);
} else {
  initPDFViewer();
}